module.exports = __webpack_public_path__ + "fonts/open-sans-v17-latin-700.f24f4bc.woff";